import {CoreBase} from "@core/base/core-base";
import {OfficeChat} from "@core/office/office-chat/office-chat";
import {OfficeChatSetting} from "@core/office/office-chat-setting/office-chat-setting";
import {Injectable} from "@angular/core";
import {OfficeChatAction} from "@core/office/office-chat-action/office-chat-action";
import {OfficeSessionService} from "@core/office/office-session/office.session.service";
import { OfficeSubscription } from "@core/office/office-subscription/office-subscription";
import { ICoreDependencies } from "@core/core-boot/core-boot.types";
import { OfficeChatRepository } from "@core/office/office-chat-repository/office-chat-repository";
import { ChatUtilsService } from "@core/shared/chat-utils.service";
import { OfficeService } from "@core/office/office-service/office-service";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CoreOffice extends CoreBase implements CoreBase {
    constructor(
        public chatSetting: OfficeChatSetting,
        public chat: OfficeChat,
        public chatAction: OfficeChatAction,
        public session: OfficeSessionService,
        public subscription: OfficeSubscription,
        public chatUtils: ChatUtilsService,
        public office: OfficeService,
    ) {
        super();
    }

    static async bootstrap(dependencies: ICoreDependencies): Promise<CoreOffice> {
        const office = new OfficeService();
        await firstValueFrom(office.initState$);
        const subscription = new OfficeSubscription(dependencies.http);
        const session = new OfficeSessionService(dependencies.http, subscription);
        const chatRepository = new OfficeChatRepository(dependencies.db);
        const chatSetting = new OfficeChatSetting(office, session, chatRepository);
        const chatUtils = new ChatUtilsService();
        const chat = new OfficeChat(dependencies, office, chatRepository, chatUtils, chatSetting,  session);
        const chatAction = new OfficeChatAction(dependencies, office, chat, chatUtils);

        return new CoreOffice(
            chatSetting,
            chat,
            chatAction,
            session,
            subscription,
            chatUtils,
            office
        )
    }
}
